import React, { useEffect } from "react";
import { endLoader } from "../../utils/Functions";
import gsap from "gsap";
import Header from "../commonComponent/Header";
import PrivacySectionOne from "./PrivacySectionOne";
import { PrivacyScreenContainer } from "../../style/privacy.style";
import Footer from "../commonComponent/Footer";
import { ReviewPageTail } from "../../style/home.style";
import SplitType from "split-type";
import { useDispatch } from "react-redux";
import { onTogglePreLoader } from "../../service/Redux/UserStore";

export default function Privacy() {
  const dispatch = useDispatch();
  useEffect(() => {
    const timeline = gsap.timeline();
    dispatch(onTogglePreLoader(false));
    endLoader(timeline);
    const navbar = document.querySelector(".header");
    const animatedTextWe = document.querySelector("#privacy-header");
    const charWeText = new SplitType(animatedTextWe, { types: "chars" });
    const PrivacyText = document.querySelector("#privacy-text");
    timeline.from(
      navbar,
      {
        y: -navbar.clientHeight,
        opacity: 0.4,
        duration: 1,
        delay: 0.3,
      },
      "-=80%"
    );
    timeline.from(
      charWeText.chars,
      {
        opacity: 0,
        y: charWeText.chars[0].clientHeight,
      },
      "-=150%"
    );
    timeline.from(PrivacyText, {
      opacity: 0,
    });
  }, []);
  return (
    <React.Fragment>
      <PrivacyScreenContainer>
        <Header />
        <PrivacySectionOne />
        <ReviewPageTail style={{ position: "absolute", bottom: -100 }} />
      </PrivacyScreenContainer>
      <Footer />
    </React.Fragment>
  );
}
